import { Flex, InputGroup, Input, Spinner, Box } from "@chakra-ui/react";

import { QueryFilter } from "@/api/claimsInvoicingApi";
import { CloseIcon, SearchIcon } from "@digital-services-gard-as/anchor-icons";
import { Button } from "@digital-services-gard-as/anchor-react";

type SearchProps = {
    id: string;
    placeholder: string;
    queryFilter: QueryFilter;
    searchText?: string;
    isFetchingData: boolean;
    handleSearchCriteriaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    handleSearchClick: () => void;
    handleClearSearch: () => void;
};

export const Search = ({
    id,
    placeholder,
    queryFilter,
    isFetchingData,
    searchText,
    handleSearchCriteriaChange,
    handleKeyUp,
    handleSearchClick,
    handleClearSearch
}: SearchProps) => {
    return (
        <Flex w="100%" alignItems="center" h="fit-content">
            <InputGroup
                maxW="40rem"
                startElement={
                    <Box pointerEvents="auto">
                        <Button
                            variant="tertiary"
                            aria-label={"Search"}
                            data-testid={id + "SearchBtn"}
                            onClick={handleSearchClick}
                            disabled={isFetchingData}
                        >
                            <SearchIcon />
                        </Button>
                    </Box>
                }
                endElement={
                    <>
                        {queryFilter.query && (
                            <Button
                                data-testid={id + "ClearSearchBtn"}
                                aria-label="Clear search"
                                variant="tertiary"
                                onClick={handleClearSearch}
                            >
                                <CloseIcon width="1.25rem" height="auto" />
                            </Button>
                        )}
                        {isFetchingData && <Spinner size="sm" />}
                    </>
                }
            >
                <Input
                    data-testid={id + "Search"}
                    type="text"
                    placeholder={placeholder}
                    value={searchText ?? queryFilter.query}
                    onChange={handleSearchCriteriaChange}
                    onKeyUp={handleKeyUp}
                    tabIndex={0}
                    border="1px solid"
                    borderColor="anchor.brown.500"
                    color="anchor.gray.600"
                    fontSize="1rem"
                    size="lg"
                />
            </InputGroup>
        </Flex>
    );
};
